export const DocFlowMappingWidgetWithSelectedAreaNotificationType = {
  AreaFound: 'areaFound',
  AreaNotFound: 'areaNotFound',
  MappingInProcess: 'mappingInProcess',
  NotChanged: 'notChanged',
  Phase: 'phase',
  ServerError: 'serverError',
  TestInProcess: 'testInProcess',
}
